import React from 'react';
import { Typography } from '@telus-uds/components-web';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const SuccessMessage = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        FORGOT_PASSWORD_MESSAGES: { NOTE, CONFIRMATION_MESSAGE }
      }
    }
  } = localizedStrings;
  return (
    <>
      <div
        id="email_sent"
        className="informational_message"
        style={{ marginTop: 15 }}
      >
        <span
          className="frg-icon icon-warning-inverted"
          style={{
            fontSize: 14,
            color: '#66cc00',
            marginRight: 5
          }}
        />
        <Typography>
          <b>{NOTE}</b>: {CONFIRMATION_MESSAGE}
        </Typography>
      </div>
    </>
  );
};

export default SuccessMessage;
